/**
 * Author : zhengyanfeng.
 * Date   : 2021/1/5.
 * File   : province. 城市id对象
 */
export default {
  '350902': {
    position: {
      left: '762px',
      top: '532px',
      zIndex: 13
    },
    background: '/static/mapPoint/mapPicture/fujian/ningde/jiaocheng.png',
    diningList: [
      {
        departmentName: '高级中学',
        departmentId: 'D51A829E74C3B40C78A598E553A9CCEB8',
        position: {
          left: '100px',
          top: '50px'
        },
        active: '01'
      }
    ]
  },
  '350981': {
    position: {
      left: '889px',
      top: '370px'
    },
    background: '/static/mapPoint/mapPicture/fujian/ningde/fuan.png',
    diningList: [
      {
        departmentName: '民族中学',
        departmentId: 'D4E758C229A0C46779F6BB33B731FDB1C',
        position: {
          left: '50px',
          top: '51px'
        },
        active: '01'
      }
    ]
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/mapPoint/diningPoint/fujian/ningde.js
// module id = null
// module chunks = 